/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Query_PlansInputs */

const en_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Query plans`)
};

const ar_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطط الاستعلام`)
};

const bn_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কুয়েরি প্ল্যান`)
};

const de_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abfragepläne`)
};

const es_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planes de consulta`)
};

const fr_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans de requête`)
};

const pt_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planos de consulta`)
};

const zh_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查询计划`)
};

const tr_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorgu planları`)
};

const ru_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Планы запросов`)
};

const pl_svchip_query_plans = /** @type {(inputs: Svchip_Query_PlansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plany zapytań`)
};

/**
* | output |
* | --- |
* | "Query plans" |
*
* @param {Svchip_Query_PlansInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_query_plans = /** @type {((inputs?: Svchip_Query_PlansInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Query_PlansInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_query_plans(inputs)
	if (locale === "bn") return bn_svchip_query_plans(inputs)
	if (locale === "de") return de_svchip_query_plans(inputs)
	if (locale === "es") return es_svchip_query_plans(inputs)
	if (locale === "fr") return fr_svchip_query_plans(inputs)
	if (locale === "pt") return pt_svchip_query_plans(inputs)
	if (locale === "zh") return zh_svchip_query_plans(inputs)
	if (locale === "tr") return tr_svchip_query_plans(inputs)
	if (locale === "ru") return ru_svchip_query_plans(inputs)
	if (locale === "pl") return pl_svchip_query_plans(inputs)
	return en_svchip_query_plans(inputs)
});